
import {
  Mixins, Component, Prop, Watch,
} from 'vue-property-decorator';
import BScroll from 'better-scroll';
import BSMinix from '@/views/Home/mixins/bsMixin';
import ListItem from './listItem.vue';

@Component({
  components: {
    ListItem,
  },
})
export default class ListCard extends Mixins(BSMinix) {
  @Prop() chapters?: Array<any>;

  // 章节列表滚动实例，用于渲染右侧可见滚动条并同步异步加载后的内容高度。
  private bs?: BScroll;

  public $refs!: {
    list: HTMLElement,
  };

  /**
   * 初始化章节列表滚动条。
   * @returns {void} 无返回值，仅负责创建 better-scroll 实例。
   */
  mounted() {
    this.createScroll();
  }

  /**
   * 监听章节数据变化，并在 DOM 更新后刷新滚动范围。
   * @param {Array<any> | undefined} _chapters 当前课程的章节列表。
   * @returns {void} 无返回值，仅负责同步滚动容器高度。
   */
  @Watch('chapters', { deep: true })
  onChaptersChange(_chapters?: Array<any>) {
    this.refreshScroll();
  }

  /**
   * 组件销毁前释放滚动实例，避免返回页面后残留旧滚动状态。
   * @returns {void} 无返回值，仅负责销毁 better-scroll 实例。
   */
  beforeDestroy() {
    if (!this.bs) return;
    this.bs.destroy();
    this.bs = undefined;
  }

  /**
   * 创建章节列表 better-scroll 实例。
   * @returns {void} 无返回值，仅在实例不存在时初始化。
   */
  private createScroll() {
    if (this.bs) return;
    this.bs = this.initBS(this.$refs.list, { scrollbar: { fade: false } });
  }

  /**
   * 刷新章节列表滚动范围，保证滚动条底部和真实章节底部一致。
   * @returns {void} 无返回值，仅负责刷新滚动实例。
   */
  private refreshScroll() {
    this.$nextTick(() => {
      this.createScroll();
      if (!this.bs) return;
      this.bs.refresh();
    });
  }
}
